import type { useHistory } from 'react-router-dom';
import { Candidate } from '@applied/proto/web_services/candidate_experience/proto/user_pb';
import type { JsonValue } from '@protobuf-ts/runtime';
import type { MessageType } from '@protobuf-ts/runtime';
import type { ResponseData } from 'api/http_requests';
import { getData, makeAuthenticatedRequest } from 'api/http_requests';

const candidateType = Candidate as MessageType<Candidate>;

export async function getCandidate(
  history: ReturnType<typeof useHistory>,
  candidateEmail?: string,
): Promise<Candidate | null> {
  const requestCandidate = (): Promise<ResponseData<JsonValue>> =>
    getData(
      candidateEmail ? `/api/web_offer/${candidateEmail}/candidate` : '/api/web_offer/candidate',
    );
  const response = await makeAuthenticatedRequest(requestCandidate, history);
  if (!response || response.jsonPayload === null) {
    return null;
  }
  return candidateType.fromJson(response.jsonPayload);
}
